<template>
  <div id="bannerView">
    <!-- banner -->
    <div class="swiper wap_index1_box">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in bannarList" :key="index">
          <img @click='tolink(item)' class="bannerView_img" :src="item.phone_banner" alt="" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { downloadA } from '@/utils/download'
import { customText } from '@/utils/key'
export default {
  data() {
    return {
      navbannerList: [],
    };
  },
  created() { },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.homeSwiper();
      });
    }, 300);
  },
  computed: {
    ...mapState({
      bannarList: (state) => state.init.bannarList,
    })
  },
  methods: {
    tolink(item) {

      switch (item.type) {
        case 1:
          downloadA(item.url)
          break;
        case 2:
          if (item.content) {
            localStorage.setItem(customText, item.content);
            let href = window.location.href
            window.open(`${href}custom`)
          }
          break;
        case 3:
          if (item.url) {
            this.$router.push({
              path: item.url,
            })
          }
          break;
        default:
          break;
      }
    },
    homeSwiper() {
      this.mySwiperbox1 = new Swiper(".wap_index1_box", {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper，主要是这两行
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          clickableClass: "my-pagination-clickable",
        },
        loop: true,
        centeredSlides: true,
      });
      this.mySwiperbox1.el.onmouseover = () => {
        this.mySwiperbox1.autoplay.stop();
      };
      this.mySwiperbox1.el.onmouseleave = () => {
        this.mySwiperbox1.autoplay.start();
      };
    },
  },
};
</script>
<style>
@import "../../assets/css/swiper-bundle.min.css";
</style>
<style scoped lang="scss">
#bannerView {
  width: 100%;
  height: 100%;
  background: #000 !important;

  .swiper {
    width: 100%;
    height: 100%;
    flex: 1;
  }
}

.wap_index1_box {
  width: 100%;
  height: 100%;
}

.wap_index1_box img {
  display: block;
  width: 100%;
  height: 100%;
}

.wap_index1_box .bannerView_img {
  display: block;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.wap_index1_box {
  overflow-y: auto;
  --swiper-theme-color: #ff0000;
  --swiper-pagination-color: #ff0000;
  /* 两种都可以 */
}
 .swiper-horizontal>.swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 0.2rem;
}
</style>
